import "./home.css";
import FAQ from "../Faq/Faq";
import { debounce } from "lodash";
import { useLocation } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import HowWorks from "../../components/HowWorks/HowWorks";
import { setCookie } from "../../services/cookies.service";
import { boxCategory } from "../../api/modules/b2droppie.class";
import { updateUserData } from "../../redux/slices/authSlice";
import { syncUserData } from "../../services/userSync.service";
import BoxFilters from "../../components/BoxFilters/BoxFilters";
import { toggleOnboard } from "../../redux/slices/onBoardingSlice";
import DepositMethods from "../../components/DepositMethod/DepositMethod";
import HomePageCarousel from "../../components/heroSection/HomePageCarousel";
import BattleComp from "../../components/BattleComp/BattleComp";
import BoxListCarousel from "../../components/BoxListCarousel/BoxListCarousel";
import TopBrands from "../../components/TopBrands/TopBrand";
import RewardSystem from "../../components/RewardSystem/RewardSystem";
import Slider from "../../components/Slider/Slider";
import { setTotalBoxes } from "../../redux/slices/boxSlice";

const Home = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [sortFilter, setSortFilter] = useState({
    filter_by: "box_price",
    order_by: "desc",
  });
  const params = new URLSearchParams(location.search);
  const utm = params.get("utm");
  const [boxData, setBoxData] = useState();
  const [category, setCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [showOverlay, setShowOverlay] = useState(false);
  const isSignupRoute = location.pathname === "/sign-up";
  const [boxCategories, setBoxCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const isDarkMode = useSelector((state) => state?.theme?.darkMode);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);

  useEffect(() => {
    handleTokenAndData();
  }, [location.search]);

  useEffect(() => {
    debouncedFetchBoxes(
      category,
      searchQuery,
      selectedSubCategories,
      sortFilter,
    );
  }, [category, searchQuery, selectedSubCategories, sortFilter]);

  useEffect(() => {
    if (
      location.pathname === "/reset-password" &&
      location.search.includes("token=") &&
      location.search.includes("email=")
    ) {
      dispatch(toggleOnboard({ resetPassword: true }));
    }
    if (isSignupRoute && utm) {
      dispatch(toggleOnboard({ register: true }));
    }
  }, [location.search]);

  const handleTokenAndData = async () => {
    try {
      const params = new URLSearchParams(location.search);
      const token = params.get("token");

      if (token) {
        const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;
        setCookie("token", token, expirationTime);
        try {
          const updated = await syncUserData();
          if (updated) {
            dispatch(updateUserData(updated));
          }
        } catch (err) {
          console.error("Error syncing user data:", err);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchBoxes = async (
    category,
    searchQuery,
    subCategories,
    sortFilter,
  ) => {
    setLoading(true);
    try {
      const response = await boxCategory(category, {
        page: 1,
        search: searchQuery,
        subCategories,
        filter_by: sortFilter.filter_by,
        order_by: sortFilter.order_by,
      });

      const boxData = response?.data?.boxes?.data;
      const totalBoxes = response?.data?.boxes?.total;
      dispatch(setTotalBoxes(totalBoxes));
      setBoxData(boxData);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetchBoxes = useRef(
    debounce((category, search, subCategories, sortFilter) => {
      fetchBoxes(category, search, subCategories, sortFilter);
    }, 500),
  ).current;

  useEffect(() => {
    return () => {
      debouncedFetchBoxes.cancel();
    };
  }, []);

  return (
    <>
      <Slider />
      <BoxListCarousel
        hideThis={true}
        cardData={boxData}
        category={category}
        setShowOverlay={setShowOverlay}
      />
      <TopBrands />
      <HowWorks />
      <RewardSystem />
      <FAQ limit={4} showLoadMore={true} />
    </>
  );
};

export default Home;
